// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';

// Components
import './components';

// Plugins
import './plugins';

import 'material-design-icons-iconfont/dist/material-design-icons.css';


// Application imports
import App from './App';
import router from './router';
import store from './i18n';
import VueAxios from "vue-axios";
import axios from "axios";

window.Refresh = true;

Vue.use(VueAxios, axios);

// request interceptor
axios.interceptors.request.use(function (config)
{
    // Do something before request is sent
    if (krita.$store.state.credentials.token !== '')
    {
        config.headers['Authorization'] = 'Bearer '  + krita.$store.state.credentials.token;
    }
    config.headers['Accept'] = 'application/json';
    config.headers['Content-Type'] = 'application/json';
    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});

// response intercept
axios.interceptors.response.use(function (response) {
    // Do something with response data
    return response;
}, function (error) {
    // Do something with response error
        if (error.response.status === 401 && krita.$router.currentRoute.path !== '/log-in')
    {
        krita.$store.commit('setAuthorized',false);
        krita.$router.go();
    }

    if (error.response.status === 403)
    {
        krita.$store.commit('notification/showNotificationInternal', {type:'error', msg: 'krita.notification.error.unauthorized'});
        krita.$router.push('/claims')
    }
    return Promise.reject(error);
});

// Sync store with router
//sync(store, router)

Vue.config.productionTip = false;

router.beforeEach((to, from, next) =>
{
    store.dispatch('checkAuthentication').then(response =>
    {
        if (!(to.name === 'Log In' || to.name === 'IslykillMock') && !krita.$store.state.credentials.isAuthorized)
        {
            store.commit('storeBackLink', to.path);
            next('/log-in');
        }
        else
        {
            next();
        }
    });
});

//filters

Vue.filter('kennitala',function (value) {
    if (!value) return '';
    value = value.toString();
    return [value.slice(0,6), '-', value.slice(6)].join('');
});

Vue.filter('account',function (value) {
    if (!value) return '';
    value = value.toString();
    return [value.slice(0,4), '-', value.slice(4,6), '-', value.slice(6)].join('');
});

Vue.filter('date',function (value) {
    if (!value) return '';
    value = value.toString();

    let year = value.slice(0,4);
    let month = value.slice(5,7);
    let day = value.slice(8,10);

    return [ day, '.',month,'.',year ].join('');
});

Vue.filter('dateTime',function (value) {
    if (!value) return '';
    value = value.toString();

    let year = value.slice(0,4);
    let month = value.slice(5,7);
    let day = value.slice(8,10);
    let time = value.slice(11,16);

    return [ day, '.',month,'.',year, ' ', time ].join('');
});

Vue.filter('amount', function (value) {
    if (!value) return '0 kr.';

    return [Math.ceil(value).toLocaleString('de-DE'), ' kr.'].join('').replace(',','.');
});

/* eslint-disable no-new */
let krita = new Vue({
    router: router,
    store: store,
    render: h => h(App)
}).$mount('#app');
